// extracted by mini-css-extract-plugin
export default {"label":"BroadcastViewModal_label__uqD-5"};